import { ref, watch } from "vue";
import { usePointerSwipe } from "@vueuse/core";
export default function useSwipe({ sliderRef, totalWidth, containerWidth, mutableTranslateX }) {
  let startTranslateX = 0;
  const swipeCooldown = ref(false);
  function refreshPosition() {
    const maxTranslateX = 0;
    const minTranslateX = Math.min(containerWidth.value - totalWidth.value, 0);
    mutableTranslateX.value = Math.max(minTranslateX, Math.min(mutableTranslateX.value, maxTranslateX));
  }
  const { distanceX } = usePointerSwipe(sliderRef, {
    onSwipeStart() {
      startTranslateX = mutableTranslateX.value;
    },
    onSwipeEnd() {
      setTimeout(() => {
        swipeCooldown.value = false;
      }, 300);
    },
    onSwipe() {
      swipeCooldown.value = true;
      mutableTranslateX.value = startTranslateX - distanceX.value;
      refreshPosition();
    }
  });
  watch([containerWidth, totalWidth], () => {
    refreshPosition();
  });
  return {
    swipeCooldown
  };
}
